import { inject, Injectable } from "@angular/core";
import { createBackendError, getBackendErrorMessage } from "../../../Common/Utility/UtilityError";
import { PartnerPublicRequestApi } from "../Api/PartnerPublicRequestApi";
import { PartnerPublicRequestSubmitRequest, PartnerPublicRequestSubmitResponse } from "../Dto/PartnerPublicRequestModel";
import { PartnerPublicRequestState } from "./PartnerPublicRequestState";

@Injectable({ providedIn: "root" })
export class PartnerPublicRequestEffects {
  private readonly api = inject(PartnerPublicRequestApi);
  private readonly state = inject(PartnerPublicRequestState);

  async loadContext(token: string): Promise<boolean> {
    this.state.setLoading(true);
    this.state.setError(null);

    try {
      const context = await this.api.getContext(token);
      this.state.setContext(context);
      return true;
    } catch {
      this.state.setError("This request link has expired or is unavailable. Public links expire 12 hours after they are generated.");
      return false;
    } finally {
      this.state.setLoading(false);
    }
  }

  async submitRequest(token: string, payload: PartnerPublicRequestSubmitRequest): Promise<PartnerPublicRequestSubmitResponse> {
    this.state.setSubmitting(true);
    this.state.setError(null);

    try {
      const response = await this.api.submitRequest(token, payload);
      this.state.setSubmitResult(response);
      return response;
    } catch (exception: unknown) {
      this.state.setError(getBackendErrorMessage(exception, "Unable to submit request."));
      throw createBackendError(exception, "Unable to submit request.");
    } finally {
      this.state.setSubmitting(false);
    }
  }
}
